export { admin as default, useIsProgramAdmin } from './enterprise-admin-index';
